import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Nosotros from "./pages/Nosotros";
import Familia from "./pages/EjesDeAccion/Familia";
import Empresa from "./pages/EjesDeAccion/Empresa";
import Propiedad from "./pages/EjesDeAccion/Propiedad";
import Insights from "./pages/Insights";
import HubFormativo from "./pages/HubFormativo";
import Contacto from "./pages/Contacto.js";
import Consorcio from "./pages/Consorcio.js"
import "@fontsource/poppins"; // Importa la fuente con todos los pesos
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme"; // Importa el theme
import useClarity from "./hooks/useClarity";
import ScrollToTop from "./components/ScrollToTop"; 

function App() {
  useClarity();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Normaliza los estilos */}
      <Router>
        {/* Coloca ScrollToTop aquí, dentro de Router */}
        <ScrollToTop /> 
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/consorcio" element={<Consorcio />} />
          <Route path="/ejes-de-accion/familia" element={<Familia />} />
          <Route path="/ejes-de-accion/empresa" element={<Empresa />} />
          <Route path="/ejes-de-accion/propiedad" element={<Propiedad />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/hub-formativo" element={<HubFormativo />} />
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;